import { IGroupsSetAction } from './types';
import { AT_GROUPS_SET } from './constants';
import { IChatGroups } from '../types';

export const chatGroupsSetAction = (
    groups: IChatGroups,
): IGroupsSetAction => ({
    type: AT_GROUPS_SET,
    groups,
});
